import React from 'react';
import ReactDOM from 'react-dom/client';
import { LicenseInfo } from '@mui/x-data-grid-premium';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import 'bootstrap/dist/css/bootstrap.css';
import {createTheme, ThemeProvider} from "@mui/material";
import {ruRU} from '@mui/material/locale';
import {store} from "./store/store";
import {Provider} from "react-redux";
import {HashRouter} from "react-router-dom";

LicenseInfo.setLicenseKey('302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286');

const theme = createTheme(
    {

    },
    ruRU,
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThemeProvider theme={theme}>
        <Provider store={store}>
            <HashRouter>
                <App/>
            </HashRouter>
        </Provider>
    </ThemeProvider>
);

reportWebVitals();
